export const portfolios = [
  {
    author: "Elsa Vania",
    title: "Dampak Kondisi Sanitasi dan Jumlah Kasus Penyakit di Jawa Barat 2018",
    image: "📊"
  },
  {
    author: "Muhammad Julizar",
    title: "Dampak Jenis Bahan Bakar Terhadap Emisi CO2",
    image: "📈"
  },
  {
    author: "Kenny Arlexy",
    title: "Korelasi Indeks Pembangunan (IPM) dan Konsumsi Alkohol",
    image: "📉"
  },
  {
    author: "Sarah Wijaya",
    title: "Analisis Tren E-Commerce di Indonesia 2023",
    image: "🛒"
  }
];
